const VALID_RELATIONSHIPS = ['team', 'cross-team', 'skip-level', 'external']

function isValidRelationship(value) {
  return VALID_RELATIONSHIPS.includes(value)
}

function generateId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return `k_${crypto.randomUUID().slice(0, 8)}`
  }
  return `k_${Math.random().toString(36).slice(2, 10)}`
}

export function migrateKudosData(raw) {
  if (!raw || typeof raw !== 'object') {
    return { items: [] }
  }

  const rawItems = Array.isArray(raw.items) ? raw.items : []

  const migrated = rawItems
    .map((legacy) => {
      if (!legacy || typeof legacy !== 'object') return null

      // Already in new format (has 'name' field)
      if ('name' in legacy) {
        return {
          id: legacy.id || generateId(),
          name: typeof legacy.name === 'string' ? legacy.name : '',
          description: typeof legacy.description === 'string' ? legacy.description : '',
          relationship: isValidRelationship(legacy.relationship) ? legacy.relationship : null,
        }
      }

      // Legacy { who, what } format
      if ('who' in legacy || 'what' in legacy) {
        return {
          id: generateId(),
          name: typeof legacy.who === 'string' ? legacy.who : '',
          description: typeof legacy.what === 'string' ? legacy.what : '',
          relationship: null,
        }
      }

      return null
    })
    .filter(Boolean)
    .slice(0, 2)

  return { items: migrated }
}
